import { createFileRoute } from '@tanstack/react-router';
import { OperacoesHubPage } from '../../../operacoes/hub-page.tsx';

export const Route = createFileRoute('/operacoes/')({
  component: OperacoesHubPage,
});
